<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <v-alert :value="true" dense outlined type="error" v-if="error">
          {{ error }}
        </v-alert>
        <v-alert :value="true" dense outlined type="success" v-if="message">
          {{ message }}
        </v-alert>
        <v-form>
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 text-left><h4>Lisää osasto</h4></v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Osaston nimi"
                  prepend-icon="mdi-home-group"
                  :rules="[rules.required]"
                  v-model="addDepartmentValues.departmentName"
                  autocomplete="off"
                />
              </v-flex>

              <v-flex xs12 md12>
                <v-autocomplete
                  prepend-icon="mdi-traffic-light"
                  v-model="addDepartmentValues.departmentState"
                  :items="departmentState"
                  item-text="name"
                  item-value="value"
                  label="Tila"
                  placeholder="Valitse"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn
                  class="mx-0 font-weight-light"
                  color="general"
                  @click.prevent="addNewDepartment"
                >
                  Lisää osasto
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DepartmentService from '@/services/ClothesToRentalDepartmentService.js';
export default {
  data() {
    return {
      departmentState: [
        { name: 'Aktiivinen', value: 'active' },
        { name: 'Passiivinen', value: 'passive' },
      ],
      addDepartmentValues: {},
      message: null,
      error: null,
      rules: {
        required: (value) => !!value || 'Pakollinen kenttä',
      },
    };
  },
  methods: {
    async addNewDepartment() {
      try {
        const response = await DepartmentService.addClothesToRentalDepartment(
          this.addDepartmentValues
        );

        this.message = response.data.message;
        this.error = response.error;
        setTimeout(() => {
          this.error = null;
          this.message = null;
        }, 3000);
      } catch (error) {
        this.error = error.response.data.error;
        setTimeout(() => {
          this.error = null;
        }, 3000);
      }
    },
  },
};
</script>
